<template>
    <div class="grid grid-cols-3 animate-pulse gap-x-3 gap-y-7 lg:grid-cols-5 md:grid-cols-4 xl:grid-cols-6 sm:gap-x-5 sm:gap-y-9">
        <div v-for="index in 12" :key="index">
            <div class="aspect-[2/3] rounded-[3px] bg-[var(--c-skeleton)]" />
            <div class="mt-3 h-3.5 w-3/4 rounded bg-[var(--c-skeleton)]" />
            <div class="mt-2 h-3 w-1/2 rounded bg-[var(--c-fill-subtle)]" />
        </div>
    </div>
</template>
